import { createApp } from 'vue'
import App from './App.vue'
// Vuetify
import 'vuetify/styles'
import { createVuetify } from 'vuetify'
import * as components from 'vuetify/components'
import * as directives from 'vuetify/directives'

//i18n
import { createI18n } from 'vue-i18n'
import messages from './lang';

import router from './router'
import store from './store/LandingPage'

const i18n = createI18n({
  legacy: false, // you must specify 'legacy: false' option in order to use vue 3 composition api, otherwise it's for vue 2 option api
  locale: 'he', // set locale
  fallbackLocale: 'he', // set fallback locale, mean default locale if translation is missing
  messages, // set locale messages
})
export default i18n;

const vuetify = createVuetify({
    components,
    directives,
  })
  const app = createApp(App)
  app.use(router)
  app.use(store)
  app.use(vuetify)
  app.use(i18n)
  app.mount('#app')
